import { render, staticRenderFns } from "./Reauthorize.vue?vue&type=template&id=21d0f884&scoped=true&"
import script from "./Reauthorize.vue?vue&type=script&lang=js&"
export * from "./Reauthorize.vue?vue&type=script&lang=js&"
import style0 from "./Reauthorize.vue?vue&type=style&index=0&id=21d0f884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d0f884",
  null
  
)

export default component.exports